import { Link } from "react-router-dom";
import { articles } from "@/mocks/data";

const articleImages: Record<string, string> = {
  "article-1": "https://readdy.ai/api/search-image?query=Soft%20romantic%20abstract%20background%20with%20warm%20pink%20and%20rose%20gold%20gradient%20delicate%20floating%20petals%20minimalist%20artistic%20style%20clean%20simple%20composition&width=800&height=500&seq=article-registration-01-hp&orientation=landscape",
  "article-2": "https://readdy.ai/api/search-image?query=Warm%20romantic%20abstract%20pattern%20with%20soft%20coral%20and%20peach%20gradients%20intertwined%20hearts%20subtle%20glow%20effects%20elegant%20minimalist%20design&width=800&height=500&seq=article-matching-01-hp&orientation=landscape",
  "article-3": "https://readdy.ai/api/search-image?query=Gentle%20abstract%20shield%20motif%20with%20soft%20rose%20and%20gold%20gradients%20floating%20light%20particles%20dreamy%20atmosphere%20clean%20minimalist%20illustration&width=800&height=500&seq=article-safety-01-hp&orientation=landscape",
};

export default function ArticlesSection() {
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-page">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              精选<strong>文章推荐</strong>
            </h2>
            <p className="text-foreground-600 leading-relaxed">
              浏览最新的注册指南、功能教程和交友技巧，快速上手爱情岛网站。
            </p>
          </div>
          <Link
            to="/category"
            className="whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.id] || articleImages["article-1"]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full text-xs font-medium bg-background-50/90 text-primary-500">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}